import {
  ChainIdLegacy,
  DEFAULT_CHAIN_ID,
  SupportedChainValue,
  createChainValueGetter,
  isSupportedChainId,
} from "@silo/types";

const builders = {
  etherscan: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://${chainName ? `${chainName}.` : ""}etherscan.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  arbitrum: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = `https://arbiscan.io`;
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  optimism: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = "https://optimistic.etherscan.io";
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },

  base: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => {
    const prefix = "https://basescan.org";
    switch (type) {
      case "transaction":
        return `${prefix}/tx/${data}`;
      default:
        return `${prefix}/${type}/${data}`;
    }
  },
};

const chains: SupportedChainValue<{
  chainName: string;
  builder: (
    chainName: string,
    data: string,
    type: "transaction" | "token" | "address" | "block"
  ) => string;
}> = {
  [ChainIdLegacy.MAINNET]: {
    chainName: "",
    builder: builders.etherscan,
  },
  [ChainIdLegacy.ARBITRUM]: {
    chainName: "",
    builder: builders.arbitrum,
  },
  [ChainIdLegacy.OPTIMISM]: {
    chainName: "",
    builder: builders.optimism,
  },
  [ChainIdLegacy.BASE]: {
    chainName: "",
    builder: builders.base,
  },
  [ChainIdLegacy.LOCAL]: {
    chainName: "",
    builder: builders.etherscan,
  },
  [ChainIdLegacy.ANVIL]: {
    chainName: "",
    builder: builders.etherscan,
  },
};

export function getExplorerLink(
  chainId: ChainIdLegacy,
  data: string,
  type: "transaction" | "token" | "address" | "block"
): string {
  const _chainId = isSupportedChainId(chainId) ? chainId : DEFAULT_CHAIN_ID;
  const chain = chains[_chainId];
  return chain.builder(chain.chainName, data, type);
}

const EXPLORER_NAME: SupportedChainValue<string> = {
  [ChainIdLegacy.MAINNET]: "Etherscan",
  [ChainIdLegacy.ARBITRUM]: "Arbiscan",
  [ChainIdLegacy.OPTIMISM]: "OP Mainnet Etherscan",
  [ChainIdLegacy.BASE]: "BaseScan",
  [ChainIdLegacy.LOCAL]: "Etherscan",
  [ChainIdLegacy.ANVIL]: "Etherscan",
};

export const getExplorerName = createChainValueGetter(
  "Etherscan",
  EXPLORER_NAME
);
